import { useMemo } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import { useLocalStorage } from '@/hooks/useLocalStorage.hook';
import useMediaQuery from '@/hooks/useMediaQuery.hook';

import { MediaQueriesEnum } from '@/enums/mediaQueries.enum';
import { RoutesEnum } from '@/enums/routes.enum';
import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { addIdToRoute } from '@/routes/types';

export const useSettings = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const [isMobile, isTablet, isDesktop] = useMediaQuery([
    MediaQueriesEnum.isMobile,
    MediaQueriesEnum.isTablet,
    MediaQueriesEnum.isDesktop,
  ]);

  const pagesWithBackButton = useMemo(
    () =>
      [
        RoutesEnum.game,
        RoutesEnum.rules,
        addIdToRoute(RoutesEnum.contestRules, id),
        RoutesEnum.help,
        RoutesEnum.termsAndConditions,
      ].includes(pathname as RoutesEnum),
    [id, pathname]
  );

  const { value: lang } = useLocalStorage<string>(StorageKeysEnum.i18nextLng);

  return { isMobile, isTablet, isDesktop, pagesWithBackButton, lang };
};
